import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import ReactMarkdown from "markdown-to-jsx";
import React from "react";

const options = {
  overrides: {
    h1: { component: Typography, props: { gutterBottom: true, variant: "h1" } },
    h2: { component: Typography, props: { gutterBottom: true, variant: "h2" } },
    h3: { component: Typography, props: { gutterBottom: true, variant: "h3" } },
    h4: { component: Typography, props: { gutterBottom: true, variant: "h4" } },
    h5: { component: Typography, props: { gutterBottom: true, variant: "h5" } },
    h6: { component: Typography, props: { gutterBottom: true, variant: "h6" } },
    p: { component: Typography, props: { paragraph: false, variant: "body1" } },
    a: { component: Link },
  },
  forceBlock: true,
  // forceInline: true,
};

export default function Markdown(props: any) {
  return <ReactMarkdown options={options} {...props} />;
}
